module.exports = __webpack_public_path__ + "img/Abschnittsleiter_Rettungsdienst.065a9721.svg";